import { render, staticRenderFns } from "./FmlSwitchEditor.vue?vue&type=template&id=a8b040e0&"
import script from "./FmlSwitchEditor.vue?vue&type=script&lang=js&"
export * from "./FmlSwitchEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports